<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';

interface BIPEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const VISIT_KEY = 'aniping-visit-count';
const DISMISS_KEY = 'aniping-install-dismissed';
const visible = ref(false);
let deferred: BIPEvent | null = null;

function handler(e: Event): void {
  e.preventDefault();
  deferred = e as BIPEvent;
  const visits = Number.parseInt(localStorage.getItem(VISIT_KEY) ?? '0', 10);
  if (visits >= 2 && localStorage.getItem(DISMISS_KEY) !== '1') {
    visible.value = true;
  }
}

onMounted(() => {
  const visits = Number.parseInt(localStorage.getItem(VISIT_KEY) ?? '0', 10);
  localStorage.setItem(VISIT_KEY, String(visits + 1));
  window.addEventListener('beforeinstallprompt', handler);
});

onUnmounted(() => {
  window.removeEventListener('beforeinstallprompt', handler);
});

async function install(): Promise<void> {
  if (!deferred) return;
  await deferred.prompt();
  await deferred.userChoice;
  deferred = null;
  visible.value = false;
}

function dismiss(): void {
  localStorage.setItem(DISMISS_KEY, '1');
  visible.value = false;
}
</script>

<template>
  <Transition name="fade">
    <div
      v-if="visible"
      class="fixed bottom-20 inset-x-3 z-40 card-elevated p-3 flex items-center gap-3 border-accent/40"
    >
      <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-accent to-accent-warm flex items-center justify-center text-xl shrink-0">
        🔔
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-sm font-semibold">Install AniPing</p>
        <p class="text-xs text-fg-muted">Add to home screen for push notifications</p>
      </div>
      <button class="btn-primary !py-2 !px-3 text-sm" @click="install">Install</button>
      <button class="btn-icon" aria-label="Dismiss" @click="dismiss">✕</button>
    </div>
  </Transition>
</template>
